import React, { useState, useRef, useEffect } from 'react';
import './MobileRecursiveMenu.css';
import { RightOutlined, DownOutlined } from '@ant-design/icons';
import CONSTANTS from 'constants';

const MobileRecursiveMenu = ({
  item,
  depth = 0,
  style = {},
  titleStyle = {},
  childrenStyle = {},
  forceClose = false, // 외부에서 메뉴 닫기 제어
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;
  const contentRef = useRef(null);

  // 외부에서 forceClose가 true일 때 열려있던 메뉴 닫기
  useEffect(() => {
    if (forceClose) {
      setIsOpen(false);
    }
  }, [forceClose]);

  const handleArrowClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleTitleClick = () => {
    if (!hasChildren && item.onClick) {
      item.onClick();
    }
  };

  return (
    <div className="mobile_depth_menu_layout" style={style}>
      <div
        className={`mobile_depth_menu_container ${
          item.title === CONSTANTS.BUSINESS_CATEGORY_NAME ? 'business' : ''
        }`}
        style={{ paddingLeft: `${depth * 12}px` }}
      >
        <div
          className={`${isOpen ? 'menu-open' : ''} mobile_depth_menu_title ${
            isOpen && depth === 0 ? 'first-depth-open' : ''
          }`.trim()}
          style={titleStyle}
        >
          <h4 onClick={handleTitleClick}>{item.title}</h4>
          {hasChildren && (
            <span onClick={handleArrowClick}>
              {isOpen ? <DownOutlined /> : <RightOutlined />}
            </span>
          )}
        </div>

        <div
          className={`mobile_depth_menu_children_wrapper ${
            isOpen ? 'open' : ''
          }`}
          ref={contentRef}
        >
          {hasChildren && (
            <ul className="mobile_depth_menu_children" style={childrenStyle}>
              {item.children.map((child, index) => (
                <li key={`mobile_menu_${depth}_${index}`}>
                  <MobileRecursiveMenu
                    item={child}
                    depth={depth + 1}
                    forceClose={forceClose} // 하위도 함께 닫히게 전달
                    style={style}
                    titleStyle={titleStyle}
                    childrenStyle={childrenStyle}
                  />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileRecursiveMenu;
